"use client";

import { useSyncExternalStore } from "react";

/** Nothing to subscribe to: an address never changes once it is decoded. */
function subscribe() {
  return () => {};
}

/**
 * An email address stored base64-encoded (`CONTACT_EMAIL_BASE64`), decoded only in the browser,
 * so the address never appears whole in the server's HTML or in the JavaScript bundle, where
 * address-harvesting bots look. A plain split ("name" + "@" + "domain") is not enough: the
 * production minifier evaluates it back into the whole address, while it leaves `atob` to run in
 * the browser. It stops bots that read pages and bundles, not ones that run the page like a
 * browser.
 *
 * Encode an address with `btoa`. Keep the address itself out of comments as well: production
 * source maps carry the original source.
 *
 * `undefined` on the server and until hydration, and without the script.
 */
export function useProtectedEmail(encodedAddress: string): string | undefined {
  return useSyncExternalStore(
    subscribe,
    () => atob(encodedAddress),
    () => undefined,
  );
}
